<template>
  <section>
    <div id="invoice-POS" style="font-family: Helvetica, sans-serif;">
      <center >
        <div>
          <p>
            <b>{{order.branchesByBranchId && order.branchesByBranchId.restaurantsByRestaurantId && order.branchesByBranchId.restaurantsByRestaurantId.name}}</b><br>
<!--            {{order.branchesByBranchId.areasByAreaId.name}}<br>-->
<!--            Tel:{{order.branchesByBranchId.phone1}}-->
          </p>
        </div>
      </center>
      <hr style="border: 1px solid black">
      <table width="100%" style="text-align:left; font-size:13px;">
        <tr>
          <td>Placed Date: {{this.$moment.parseZone(String(order.created)).local().format('DD-MM-YYYY')}}</td>
        </tr>
        <tr>
          <td>Placed Time: {{this.$moment.parseZone(String(order.created)).local().format('hh:mm:ss A')}}</td>
        </tr>
        <tr>
          <td>Order Id: {{order.id > 0 ? order.id : ''}}</td>
          <td>NTN: {{order.branchesByBranchId.restaurantsByRestaurantId.ntn}}</td>
        </tr>
        <tr>
          <td colspan="2" style="border-top: 1px solid #000;"></td>
        </tr>
        <tr>
          <td v-if="customer || dvmCustomer">Customer Name: {{customer ? (customer.name ? customer.name : 'N/A') : dvmCustomer.name}}</td>
          <td v-if="customer || dvmCustomer">Contact No. 1: {{customer ? customer.contact1 : dvmCustomer.contactNumber}}</td>
        </tr>
        <tr>
          <td v-if="customer && customer.contact2">Contact No. 2: {{customer.contact2}}</td>
          <td v-if="customer && customer.contact3">Contact No. 3: {{customer.contact3}}</td>
        </tr>
        <tr v-if="order.orderTypesByOrderTypeId.id ===3 && order.statusesByStatusId.id !== 12 ">
          <td>Address: {{customer ? order.customerAddressesByCustomerAddressId.address : order.dvmAddress.address}}</td>
        </tr>
        <tr v-if="order.orderTypesByOrderTypeId.id ===3 && order.statusesByStatusId.id !== 12 ">
          <td >Area: {{order.customerAddressesByCustomerAddressId ? order.customerAddressesByCustomerAddressId.areasByAreaId.name : order.dvmAddress.area}}</td>
        </tr>
      </table>
      <center><h2>{{order.orderTypesByOrderTypeId.type}}</h2></center>
      <table style=" border: 1px solid black;border-collapse: collapse;" width="100%">
        <tr>
          <th style="width:5%; border: 1px solid black;border-collapse: collapse;font-size:13px;">Sr.</th>
          <th style="width:50%; border: 1px solid black;border-collapse: collapse; text-align:left;font-size:13px;">Item Name</th>
          <th style="width:15%; border: 1px solid black;border-collapse: collapse;font-size:13px;">Rate</th>
          <th style="width:15%; border: 1px solid black;border-collapse: collapse;font-size:13px;">Qty</th>
          <th style="width:15%; border: 1px solid black;border-collapse: collapse;font-size:13px;">Total</th>
        </tr>
        <template v-for="(orderItem, orderItemIndex) in order.orderItemsById">
          <tr v-bind:key="orderItemIndex">
            <td style="width:5%;font-size:13px;border: 1px solid black;border-collapse: collapse; border-bottom:none !important">{{orderItemIndex +1}}</td>
            <td style="width:50%;text-align:left; font-size:14px;border: 1px solid black;border-collapse: collapse;"><small>{{orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name}} &nbsp; | &nbsp; {{orderItem.menuItemTypesByMenuItemTypeId.serving}}</small></td>
            <td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{orderItem.menuItemTypesByMenuItemTypeId.price | formatNumber}}</small></td>
            <td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{orderItem.quantity}}</small></td>
            <td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{orderItem.totalPrice | formatNumber}}</small></td>
          </tr>
          <template v-for="(itemAddOn, itemAddOnIndex) in orderItem.orderItemAddOnsById">
            <tr v-bind:key="orderItemIndex+'_'+itemAddOnIndex">
              <td></td>
              <td style="width:50%;text-align:left;font-size:13px;border: 1px solid black;border-collapse: collapse;"> <small>&nbsp &nbsp *{{itemAddOn.addOnItemsByAddOnItemId.name}}</small></td>
              <td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{itemAddOn.addOnItemsByAddOnItemId.price | formatNumber}}</small></td>
              <td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{itemAddOn.quantity}}</small></td>
              <td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{itemAddOn.quantity * itemAddOn.addOnItemsByAddOnItemId.price | formatNumber}}</small></td>
            </tr>
          </template>
        </template>
      </table><br>
      <center>Payment Method: {{(order.paymentMethod.id===1) ? "CASH" : "CARD"}}</center>
      <table style="width:100%">
        <tr>
          <td style="width:70%; text-align:right;font-size:13px;"> Sub Total:</td>
          <td style="width:10%;"></td>
          <td style="width:20%; text-align:left;font-size:13px;">Rs.{{formatPrice(parseFloat(order.totalPriceWithAddon).toFixed(2))}}</td>
        </tr>

        <tr>
          <td style="width:70%; text-align:right;font-size:13px;">GST@{{(order.paymentMethod.id===1)? order.branchesByBranchId.tax: order.branchesByBranchId.cardTax}}%:</td>
          <td style="width:10%;"></td>
          <td style="width:20%; text-align:left;font-size:13px;">Rs.{{Math.round((order.totalPriceAfterTax + order.discount) - order.totalPriceWithAddon )}}</td>
        </tr>
        <tr>
          <td style="width:70%; text-align:right;font-size:13px;">Discount:</td>
          <td style="width:10%;"></td>
          <td style="width:20%; text-align:left;font-size:13px;">Rs.{{formatPrice(parseFloat(order.discount).toFixed(2))}}</td>
        </tr>
        <tr>
          <td style="width:70%; text-align:right;font-size:13px;">Delivery Fee:</td>
          <td style="width:10%;"></td>
          <td style="width:20%; text-align:left;font-size:13px;">Rs.{{formatPrice(parseFloat(order.deliveryFee).toFixed(2))}}</td>
        </tr>
        <tr>
          <td style="width:70%; text-align:right;font-size:13px;">Billed Amt:</td>
          <td style="width:10%;"></td>
          <td style="width:20%; text-align:left;font-size:14px;"><b>Rs.{{formatPrice(order.billedPrice)}}</b></td>
        </tr>
      </table>
      <br><br>
      <center>
        <b>Thank You for visiting {{order.branchesByBranchId.restaurantsByRestaurantId.name}}</b>
        <p style="font-size:10px;">
          To Place Your Order or To Give FeedBack, Call Us At 03005003318.
        </p>
      </center>

    </div>
  </section>
</template>

<script>
import numeral from 'numeral';
export default {
  name:"PrintOrder",
  // data () {
  //   return {
  //     order: {}
  //   }
  // },
  props: {
    order :{
      type: Object,
      required: true
    }
  },
  computed: {
    customer() {
      return this.order.customerAddressesByCustomerAddressId !== null ? this.order.customerAddressesByCustomerAddressId.customersByCustomerId : false;
    },
    dvmCustomer() {
      return this.order.dvmAddress !== null ? this.order.dvmAddress.dvmCustomer : false
    }
  },
  // watch: {
  //   originalOrder:{
  //     handler(val) {
  //       this.order = val
  //     },
  //     deep: true,
  //     // immediate: true
  //   }
  // },
  methods: {
    formatPrice(value) {
      if(value !== null){
        return numeral(value).format('0,0[.]00'); //[00] to format to two decimal number
      }
    },
  }

}
</script>

<style scoped>
.center {
  margin-left: auto;
  margin-right: auto;
}
</style>